import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import clsx from "clsx";
import Link from "next/link";
import styles from "./index.module.scss";
import Maper from "../../pages/contacts/maper";

export default function Map({ isShowTitle = true }) {
  const { contacts, shops = [] } = useSelector((state) => state.contacts);
  const [pointId, setPointId] = useState(null);

  const zoom = 8;
  const sectionRef = useRef(null);
  return (
    <div className={styles.Block}>
      <div className={styles.Head}>
        {isShowTitle && <h2>Контакты</h2>}

        <div className={styles.Info}>
          <div>
            <div className={styles.InfoLabel}>Телефон:</div>
            <a
              href={`tel:${contacts?.phone}`}
              className={contacts?.calltouchCode}
            >
              {contacts?.phone}
            </a>
          </div>
          <div>
            <div className={styles.InfoLabel}>E-mail:</div>
            <a href={`mailto:${contacts?.email}`}>{contacts?.email}</a>
          </div>
        </div>
      </div>
      <div className={styles.Body}>
        <div className={styles.Adr}>
          {shops.map((shop, i) => (
            <div
              key={shop.id ?? i}
              className={clsx(
                styles.AdrBlock,
                shop.id === pointId && styles.AdrBlockSelected,
              )}
              onClick={() => {
                setPointId(shop.id);
                if (window.outerWidth < 991) {
                  sectionRef.current?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              {shop.directionsScheme && (
                <div className={styles.Scheme}>Схема проезда</div>
              )}
              <div>
                <div className={styles.AdrBlockLabel}>Адрес:</div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: shop.address ?? "",
                  }}
                />
              </div>
              {shop.workingHours && (
                <div>
                  <div className={styles.AdrBlockLabel}>Режим работы:</div>
                  <span>{shop.workingHours}</span>
                </div>
              )}
            </div>
          ))}
          <div className={styles.AdrBottom}>
            <div className={styles.AdrBottomNews}>
              <div>Читайте нас на:</div>
              <div className={styles.Read}>
                <a
                  className={styles.Drive2}
                  href="https://www.drive2.ru/users/farkopru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/drive2.svg" />
                </a>
                <a
                  className={styles.Drive2}
                  href="https://vk.com/farkopru"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/vk.svg" />
                </a>
              </div>
            </div>
            <div className={styles.AdrBottomSoc}>
              <div>Социальные сети:</div>
              <div className={styles.SocList}>
                <Link href="https://vk.com/farkopru">
                  <a target="_blank" rel="nofollow">
                    <img src="/soc/3.svg"></img>
                  </a>
                </Link>
                <Link href="https://rutube.ru/channel/33712357/">
                  <a target="_blank" rel="nofollow">
                    <img src="/soc/4.svg"></img>
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.Map} ref={sectionRef}>
          <Maper zoom={zoom} points={shops} pointId={pointId} />
        </div>
      </div>
    </div>
  );
}
